var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWifiSlash = function SvgIconWifiSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.827 3.01a1 1 0 0 1 1.413.067l5.614 6.175.023.027 4.856 5.34q.057.055.104.115l4.403 4.843a1 1 0 0 1-1.48 1.346l-4.417-4.859a3.77 3.77 0 0 0-4.943.231 1 1 0 1 1-1.382-1.446 5.77 5.77 0 0 1 3.772-1.594l-2.007-2.207a8.2 8.2 0 0 0-3.552 2.05 1 1 0 0 1-1.4-1.428c1-.98 2.186-1.74 3.482-2.24L6.536 7.477a12.8 12.8 0 0 0-3.49 2.443 1 1 0 0 1-1.404-1.425A14.8 14.8 0 0 1 5.14 5.939L3.76 4.423a1 1 0 0 1 .067-1.413"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.003 6.25a12.65 12.65 0 0 1 8.94 3.666 1 1 0 1 0 1.408-1.42A14.65 14.65 0 0 0 11.999 4.25c-.364 0-.74.01-1.113.041a1 1 0 1 0 .166 1.993q.452-.036.948-.034zm-.004-2zv1l-.003-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.817 10.123a1 1 0 0 1 1.32-.51 10.3 10.3 0 0 1 3.031 2.057 1 1 0 1 1-1.398 1.429 8.3 8.3 0 0 0-2.444-1.657 1 1 0 0 1-.509-1.319M13.5 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconWifiSlash;